import { Component } from '@angular/core';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
	selector: 'plantmap-ops-home',
	templateUrl: 'plantmap-ops-home.component.html'
})
export class PlantmapOpsHomeComponent {

    constructor(
        private _layoutService: LayoutService
	){}
	
    ngOnInit(){
        this._layoutService.setCurrentPage('plantmap-ops-home');
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/home/components/plantmap-ops-home.component.ts